import { HttpClient, HttpParams } from '@angular/common/http';
import {
  Translation,
  TranslocoLoader,
  TranslocoModule,
  provideTranslocoLoader,
  provideTransloco,
} from '@jsverse/transloco';
import { Injectable, NgModule } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    const base = `/assets/i18n/${lang}.json`;

    return this.http.get<Translation>(base, {
      params: new HttpParams().set('t', new Date().toISOString().slice(0, -8)),
    });
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['fi', 'sv', 'en'],
        defaultLang: 'fi',
        fallbackLang: 'fi',
        missingHandler: {
          useFallbackTranslation: true,
        },
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
    }),
    provideTranslocoLoader(TranslocoHttpLoader),
  ],
})
export class TranslocoRootModule {}
